<template>
  <withTopNav :leftText="detail.activityConfigName" class="jiujijin text-13" fixed>
    <div
      class="bgs-[url('')] pt-[186px] text-center"
     :class="info.resetType"
    >
      <p class="pt-3 pb-5 text-15" v-if="info.startTime && info.endTime">
        Das
        <span class="text-[#EEE54C]">{{ dayjs.utc(info.startTime).local().format('YYYY-MM-DD HH:mm') }}</span>
        às
        <span class="text-[#EEE54C]">{{ dayjs.utc(info.endTime).local().format('YYYY-MM-DD HH:mm') }}</span>
      </p>
    </div>
    <div class="main px-4">
      <div
        class="mainContent bgs-[url('@a/assets/images/b_jjj.png')] bg-[var(--theme-gray-green40)] rounded-20 p-[24px_16px_16px]"
      >
        <div class="flex-center-y text-[var(--theme-text-dark)]">
          <img v-if="info.resetType == 'Daily'" src="@a/assets/images/i_day_1.png" class="size-6 mr-2" alt="" />
          <img v-else-if="info.resetType == 'Weekly'" src="@a/assets/images/i_week2.png" class="size-6 mr-2" alt="" />
          <p class="flex-1">Compensação deste período：</p>
          <span class="text-15">R$ {{ formatter().format(info.predictAmount) }}</span>
        </div>
        <div class="flex-center-y text-[var(--theme-text-dark)] mt-4">
          <img src="@a/assets/images/i_rs.png" class="size-6 mr-2" alt="" />
          <p class="flex-1">Lucro deste período：</p>
          <span class="text-15">R$ {{ formatter().format(info.cycleLoss) }}</span>
        </div>

        <div class="flex-center-col mt-21.5">
          <img
            src="@a/assets/images/i_day.png"
            v-if="info.resetType == 'Daily'"
            class="wh-[53px_45px]"
            alt=""
          />
          <img
            src="@a/assets/images/i_week.png"
            v-else-if="info.resetType == 'Weekly'"
            class="wh-[53px_45px]"
            alt=""
          />

          <p class="text-center leading-18 pt-4">
            A compensação deste período será distribuída<br />às
          </p>

          <div class="flex-center-y text-15 mt-2 mb-4">
            <img src="@a/assets/images/i_tar.png" class="size-6 mr-3" alt="" />
            <p class="text-[#0BCF33] font-[600]">
              {{ dayjs.utc(info.estimatedTime).local().format('YYYY-MM-DD HH:mm') }}
            </p>
          </div>

          <p class="text-15">Compensação disponível</p>

          <span class="text-18 text-[#0BCF33] my-3 font-[600]">R$ {{ formatter().format(info.amount ?? '0.00') }}</span>

          <van-button
            :disabled="!info.amount || info.amount == 0"
            class="primaryBtn !w-[93px] !h-[34px]"
            @click="receber"
          >Receber</van-button>
        </div>
      </div>

      <div class="my-4">
        <DataTable :columns :data="tableData" round />
      </div>

      <ActivityDesc
        class="my-4"
        title="Descricão da Atividade"
        :list="descList"
      />
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
  import withTopNav from '@/layouts/withTopNav.vue'
  import DataTable from '@a/components/DataTable/index.vue'
  import ActivityDesc from '@a/components/ActivityDesc/index.vue'
  import dayjs from 'dayjs'
  import { getReliefInfo, getReliefInfoWithoutAuth } from '@/api'
  // import { type iActivity } from '@/store'
  // import { getAcivityDetails, receberReward, getDetails } from '@/utils/activity'
  import { useActivity } from '@/hooks/useActivity'
  import { formatter } from '@/utils'
  import type { iReliefInfo } from '@/types/index'

  const route = useRoute()
  const activityId = route.query.activityId as string
  const activity = useActivity(activityId, {
    getInfo: getReliefInfo as (args: any) => Promise<any>,
    getInfoWithoutAuth: getReliefInfoWithoutAuth as (args: any) => Promise<any>
  })
  const detail = computed(() => activity.data.value.detail)
  const info = computed(() => activity.data.value.info || {
    startTime: '',
    endTime: '',
    cycleLoss: 0,
    predictAmount: 0,
    estimatedTime: '',
    amount: 0,
    rewardConfigs: [],
    desc: '',
    resetType: 'None',
    rewardType: '',
    awardLimitSms: false,
  }) as Ref<iReliefInfo>
  const descList = computed(() => activity.data.value.descList || [])

  const columns = [
    {
      title: 'Lucro diário',
      key: 'k1',
    },
    {
      title: 'Compensação',
      key: 'k2',
    },
  ]

  const tableData = computed(() => {
    return info.value.rewardConfigs.map((item) => {
      return {
        k1: `-${item.loss}`,
        k2: `${item.proportion}${info.value.rewardType == 'CashRatio' ? '%' : ''}`,
      }
    })
  })

  const receber = () => {
    activity.receber({
      flowType: 'AidReward',
      activityId,
    })
  }
</script>

<style lang="scss">
  .jiujijin {

    .Daily {
      background-image: url('@a/assets/images/banner_jjj_day.png');
    }
    .Weekly {
      background-image: url('@a/assets/images/banner_jjj_week.png');
    }
  }
</style>
